<template>
  <div>
    <table class="table table-striped mb-0">
      <tbody>
        <tr
                v-if="machinesRiskStatus.length"
                v-for="machineRiskStatus in machinesRiskStatus"
        >
          <td>
            <span
                    class="rounded-circle px-3 py-1 mr-3"
                    :style="{
                    backgroundColor: machineRiskStatus.color,
                    }"
            ></span>
            {{ machineRiskStatus.name }}
          </td>
          <td class="text-right">
            {{ machineRiskStatus.result > 0 ? machineRiskStatus.result : '-' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      machinesRiskStatus: Array
    },
  }
</script>